import React, { useRef, useEffect } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import ScrollReveal from './utils/ScrollReveal';
import ReactGA from 'react-ga4';
import { useTranslation } from './i18n/LanguageProvider';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views 
import Home from './views/Home';
import About from './views/About';
import Blog from './views/Blog';
import ContactConfirmation from './views/ContactConfirmation';
import Contact from './views/Contact';
import NotImplementedSection from './components/sections/NotImplementedSection';
import NotFound from './components/sections/NotFound';
import Careers from './components/sections/Careers';

// Initialize Google Analytics
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_CODE;
if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

const trackPage = page => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({ hitType: 'pageview', page });
};

const App = () => {

  const childRef = useRef();
  const location = useLocation();
  const { language } = useTranslation();

  useEffect(() => {
    const page = `${location.pathname}${location.search}`;
    document.body.classList.add('is-loaded');
    if (childRef.current) {
      childRef.current.init();
    }
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, language]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <Routes>
          <Route path="/" element={<LayoutDefault><Home /></LayoutDefault>} />
          <Route path="/blog" element={<LayoutDefault><Blog /></LayoutDefault>} />
          <Route path="/about" element={<LayoutDefault><About /></LayoutDefault>} />
          <Route path="/careers" element={<LayoutDefault><Careers /></LayoutDefault>} />
          <Route path="/not_implemented" element={<LayoutDefault><NotImplementedSection /></LayoutDefault>} />
          <Route path="/contact" element={<LayoutDefault><Contact /></LayoutDefault>} />
          <Route path="/contact-confirmation" element={<LayoutDefault><ContactConfirmation /></LayoutDefault>} />
          <Route path="*" element={<LayoutDefault><NotFound /></LayoutDefault>} />
        </Routes>
      )} />
  );
}

export default App;
